module.exports = __webpack_public_path__ + "img/add-card.d0787ede.svg";